import { Box, Button, Container, Stack, Typography, useTheme } from '@mui/material';
import Download from '@mui/icons-material/Download';
import Chip from 'components/Chip';
import GradientHeading from 'components/GradientHeading';

const EventTitle = () => {
    const theme = useTheme();
    const programmeBookUrl = '/assets/Programme Book InaACC 2026.pdf';

    return (
        <Box bgcolor={theme.palette.alternate.main} py={4}>
            <Container>
                <Box
                    sx={{
                        textAlign: 'center',
                        mb: { xs: 6, md: 8 },
                    }}
                >
                    <Chip label="INAACC Semarang 2026" sx={{ mb: 3 }} />

                    <GradientHeading label="Indonesia Intensive & Acute Cardiovascular Care 2026" />

                    <Typography
                        variant="h5"
                        sx={{
                            color: 'text.primary',
                            fontWeight: 500,
                            maxWidth: 700,
                            mx: 'auto',
                            lineHeight: 1.6,
                            fontSize: { xs: '1.1rem', md: '1.5rem' },
                            mb: 2,
                        }}
                    >
                        Advancing Science and Practicing in Acute and Intensive
                        Cardiovascular Care Meeting
                    </Typography>

                    {/* <Stack direction="row" justifyContent="center" sx={{ mt: 3 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            href={programmeBookUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            startIcon={<Download />}
                            sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 700,
                                px: { xs: 2.5, md: 3 },
                            }}
                        >
                            Download Programme Book
                        </Button>
                    </Stack> */}

                    {/* Decorative element */}
                    <Box
                        sx={{
                            width: 100,
                            height: 4,
                            background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                            mx: 'auto',
                            mt: 4,
                            borderRadius: 2,
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default EventTitle;
